<template>
  <div>

    <div class="mobile">
      <v-container fluid>


        <div v-if="foodCategories.length === 0">
          <!--                    <div class="d-flex">-->
          <v-skeleton-loader
            class="mx-auto maxw mt-2"
            type="list-item"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto maxw mt-2"
            type="list-item"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto maxw mt-2"
            type="list-item"
          ></v-skeleton-loader>
          <!--                    </div>-->
        </div>


        <v-layout row wrap v-else>
          <v-flex xs12 md6 lg4 v-for="cat in foodCategories" :key="cat.id">
            <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat)"
                          :category="cat"></CategoryCard>
          </v-flex>
          <!--                    <v-flex xs12 md6 lg4 v-if="lastGotoDrinks">-->
          <!--                        <GotoDrinksCard class="pointer" @click.native.passive="gotoDrinks"-->
          <!--                        ></GotoDrinksCard>-->
          <!--                    </v-flex>-->
        </v-layout>

      </v-container>
    </div>

    <div class="tablet">
      <v-container grid-list-lg>

        <div v-if="foodCategories.length === 0">
          <div class="d-flex">
            <v-skeleton-loader
              class="mx-auto maxw"
              max-width="360"
              type="card"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mx-auto maxw"
              max-width="360"
              type="card"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mx-auto maxw"
              max-width="360"
              type="card"
            ></v-skeleton-loader>
          </div>

        </div>


        <v-layout row wrap v-else>
          <v-flex xs12 md6 lg4 v-for="cat in foodCategories" :key="cat.id">
            <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat)"
                          :category="cat"></CategoryCard>
          </v-flex>
          <!--                    <v-flex xs12 md6 lg4 v-if="lastGotoDrinks">-->
          <!--                        <GotoDrinksCard class="pointer" @click.native.passive="gotoDrinks"-->
          <!--                        ></GotoDrinksCard>-->
          <!--                    </v-flex>-->
        </v-layout>
      </v-container>
    </div>

  </div>

</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as qconst from '../vendor/qconstants';
import * as util from '../vendor/util'
// import {offerMixin} from "../mixins/offerMixin";
import CategoryCard from "../components/CategoryCard";
// import GotoDrinksCard from "./GotoDrinksCard";

export default {
  name: "SortimentCards",
  components: {
    CategoryCard
  },
  // mixins: [offerMixin],
  props: {
    lastGotoDrinks: {
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      foodCategories: [],
    }
  },
  created() {
    // ebus.$on('offersUpdated', () => {
    //     this.init();
    // });
    ebus.$on(qconst.notify$foodsUpdated, () => {
      this.init();
    });
  },
  destroyed() {
    util.clearEvents([
      qconst.notify$foodsUpdated,
    ]);
  },
  mounted() {
    this.init();
  },
  // activated() {
  //     this.init();
  // },
  methods: {
    init() {
      let foodCats = util.cloneMe(store.getters.foodMenu);
      let relevantF = [];
      for (let fcat of foodCats) {
        if (!fcat.items) {
          continue;
        }
        relevantF.push(fcat);
        // for (let item of fcat.items) {
        //     let offerAndItem = store.getters.getOfferByItemId(item.id);
        //     // item.offered = !!offerAndItem;
        //     // if (!!offerAndItem) {
        //     //     item.offerId = offerAndItem.offer.id;
        //     // }
        //     this.applyOfferAndPrices(item, offerAndItem);
        // }
      }
      this.foodCategories = relevantF;
    },
    gotoCategory(cat) {
      // store.commit('selectedCategoryId', cat.id);
      store.state.shouldJump = true;
      this.$router.push({name: 'SpeisenProdukte', params: {catname: cat.categoryDE}});
    },
    gotoDrinks() {
      ebus.$emit('shortcutToDrinkMenu');
    }
  }


}
</script>

<style scoped lang="scss">

/*.loader ::v-deep .v-skeleton-loader{*/
/*    width: 100%;*/
/*}*/

</style>
